module.exports = __webpack_public_path__ + "img/stores_appointment@1x@2x.c022047.jpg";